import { Checkbox } from '@indipia/ui-core';
import { formatReceivedAt } from '@indipia/shared-features';
import { ThumbImg } from '../ThumbImg';
import { CUST_REQ_REPORT_MESSAGE as MSG, sortPhotos } from './custReqReport.logic';
import type { OwnerCustReq } from './useOwnerCustReq';

/**
 * 사장님 직접 작성(C-2) '고객 요청' 행의 내용 — 요청마다 [반영] 체크.
 * 행 틀(라벨·테두리)은 작성 화면의 Row 가 맡는다. 공정이 확정되지 않았으면 호출하지 않는다.
 */
export function CustReqOwnerRows({ ctl }: { ctl: OwnerCustReq }) {
  return (
    <ul className="flex min-w-0 flex-1 flex-col gap-3">
      {ctl.targets.map((t, idx) => {
        const applied = ctl.checks[t.custReqId] === true;
        const reqPhotos = sortPhotos(t.photos);
        return (
          <li key={t.custReqId} className="rounded-md border border-border p-3">
            <div className="flex items-start gap-2">
              <span className="shrink-0 text-body-sm font-bold text-text">{idx + 1}</span>
              <div className="min-w-0 flex-1">
                <p className="text-body-sm leading-relaxed text-text" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {t.content}
                </p>
                <p className="mt-1 text-caption text-text-muted">
                  {[t.srcName, formatReceivedAt(t.receivedAt) && `${formatReceivedAt(t.receivedAt)} 접수`].filter(Boolean).join(' · ')}
                </p>
                {reqPhotos.length > 0 && (
                  <div className="mt-2 flex flex-wrap gap-2">
                    {reqPhotos.map((p) => (
                      <ThumbImg key={p.photoId} url={p.thumbUrl} alt="" className="h-12 w-12 shrink-0 overflow-hidden rounded-md" />
                    ))}
                  </div>
                )}
              </div>
              <Checkbox
                label={MSG.applied}
                checked={applied}
                onChange={(e) => ctl.setApplied(t.custReqId, e.target.checked)}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
